export default "__VITE_ASSET__gl8wjsyX__"